import { useCallback, useState } from 'react';
import { useAxios } from './useAxios';

const errorMessage = (err) =>
  err?.response?.data?.message || 'Une erreur est survenue. Réessayez dans un instant.';

export default function useAnnonceGenerator(vehicleId) {
  const axios = useAxios();
  const [state, setState] = useState({
    status: 'idle', // idle | loading | ready | saving | error
    draftId: null,
    description: '',
    source: null,
    remaining: null,
    error: null,
  });

  const generate = useCallback(async () => {
    setState((s) => ({ ...s, status: 'loading', error: null }));
    try {
      const { data } = await axios.post(`/ai/annonce/vehicles/${vehicleId}/description`);
      setState({
        status: 'ready',
        draftId: data.draftId,
        description: data.description,
        source: data.source,
        remaining: data.remaining,
        error: null,
      });
    } catch (err) {
      setState((s) => ({ ...s, status: 'error', error: errorMessage(err) }));
    }
  }, [axios, vehicleId]);

  const setDescription = useCallback((description) => setState((s) => ({ ...s, description })), []);

  const accept = useCallback(async () => {
    if (!state.draftId) return null;
    setState((s) => ({ ...s, status: 'saving', error: null }));
    try {
      const { data } = await axios.post(`/ai/annonce/drafts/${state.draftId}/accept`, {
        description: state.description,
      });
      setState((s) => ({ ...s, status: 'ready' }));
      return data.description;
    } catch (err) {
      setState((s) => ({ ...s, status: 'error', error: errorMessage(err) }));
      return null;
    }
  }, [axios, state.draftId, state.description]);

  return { ...state, generate, setDescription, accept };
}
